<template>
  <section class="invoice-add-wrapper">
    <b-row v-if="loading">
      <b-col>
        <div class="d-flex justify-content-center mb-1">
          <b-spinner variant="success" label="Spinning" block style="width: 3rem; height: 3rem"></b-spinner>
        </div>
      </b-col>
    </b-row>
    <b-row v-else class="invoice-add">
      <!-- Col: Left (Invoice Container) -->

      <b-col cols="12" xl="9" md="8">
        <b-form @submit.prevent>
          <b-card no-body class="invoice-preview-card px-2">
            <!-- Header -->
            <b-card-body class="">
              <div class="row align-items-center mb-2">
                <div class="col-md-1 col-1">
                  <Logo />
                </div>
                <div class="col-9">
                  <div class="">
                    <CompanyName />
                  </div>
                  <div class="">
                    <Address />
                  </div>
                </div>
              </div>

              <b-row class="">
                <!-- Col: Invoice To -->
                <b-col cols="6" xl="6">
                  <h4 class="mb-1">Customer</h4>
  
                  <!-- Select Client -->

                  <!-- Selected Client -->
                  <ClientAddress  :client="whenSelected" />
                  <!-- <div class="my-2">
                    <h6 class="mb-2">
                      OrderType : {{ getOptionsOrder(orderType) }}
                    </h6>
                  </div> -->
                </b-col>

                <div class="col-6 text-right">
                  <!-- Header: Right Content -->
                  <h4>
                    Proforma
                    <span class="invoice-number">#{{ salesorderId.orderNumber }}</span>
                  </h4>

                  <div class="text-right">
                    <div class="row invoice-date-wrapper justify-content-end">
                      <div class="col-md-7 col-7 d-flex justify-content-end">
                        <span class="title"> Issued Date: </span>
                      </div>
                      <div class="col-md-5 col-5 d-flex justify-content-end">
                        <flat-pickr v-model="salesorderId.issuedDate" class="form-control invoice-edit-input" disabled />
                      </div>
                    </div>

                    <div class="row invoice-date-wrapper">
                      <div class="col-md-7 col-7 d-flex justify-content-end">
                        <span class="title"> Due Date: </span>
                      </div>
                      <div class="col-md-5 col-5 d-flex justify-content-end">
                        <flat-pickr v-model="salesorderId.dueDate" class="form-control invoice-edit-input" disabled/>
                      </div>
                    </div>

                    <div class="row invoice-date-wrapper" v-if="this.vat"
                  >
                    <div class="col-md-7 col-7  justify-content-md-end">
                      <p class="invoice-date-title">VAT:</p>
                    </div>
                    <div class="col-md-5 col-5  justify-content-md-end">
                      <p class="invoice-date">
                        {{ this.vat }}
                      </p>
                    </div>
                  </div>

                    <div class="row invoice-date-wrapper" v-if="this.vat"
                  >
                    <div class="col-md-7 col-7  justify-content-md-end">
                      <p class="invoice-date-title">BRN Number:</p>
                    </div>
                    <div class="col-md-5 col-5  justify-content-md-end">
                      <p class="invoice-date">
                        {{ this.brn }}
                      </p>
                    </div>
                  </div>
                  </div>
                </div>
              </b-row>
            </b-card-body>

            <!-- Items Section -->
            <b-card-body>
              <b-table responsive bordered :fields="dynamicFields" :items="salesorderId.orderItems">

                <template #cell(productImg)="data">
                  <template v-if="data.item.itemId">
                    <img
                      :src="`${baseUrl}selfservices/getproductimage?ProductID=${data.item.itemId}`"
                      alt="Product Image" style="width: 75px; height: 75px; object-fit: cover;"
                      @error="showNoImage($event)" />
                  </template>
                  <template v-else>
                    <span>-</span>
                  </template>
                </template>

                <template #cell(cost)="data">
                  {{ parseFloat(data.item.cost).toFixed(2) }}
                </template>

                <template #cell(qty)="data">
                {{ parseFloat(data.item.qty).toFixed(2) }}
              </template>

              <template #cell(VAT)="data">
                {{  data.item.tax ? parseFloat(data.item.tax).toFixed(2) : 0 }} %
              </template>


                <template #cell(price)="data">
                  {{
                    (
                      data.item.cost * data.item.qty -
                      (data.item.discount === null ? 0 : data.item.discount)
                    ).toFixed(2)
                  }}
                </template>
                <template #cell(discount)="data">
                  {{
                    (data.item.discount === null
                      ? 0
                      : data.item.discount
                    ).toFixed(2)
                  }}
                </template>
              </b-table>
            </b-card-body>

            <!-- Invoice Description: Total -->
            <b-card-body class="">
              <b-row>
                <!-- Col: Sales Persion -->
                <b-col cols="12" md="6" class="mt-md-0 mt-3" order="2" order-md="1">
                  <b-card-text class="mb-0">
                    <span class="font-weight-bold">Salesperson :</span>
                    <span class="ml-75">{{ salesorderId.salesPersonId }} </span>
                  </b-card-text>

                  <b-card-text class="mb-0">
                    <span class="font-weight-bold">Warehouse :</span>
                    <span class="ml-75">{{ getWarehouse(salesorderId.warehouseId) }} </span>
                  </b-card-text>
                </b-col>

                <!-- Col: Warehouse -->
                <!-- <b-col cols="12" md="6" class="mt-md-0 mt-3" order="2" order-md="1">
                  
                </b-col> -->

                <!-- Col: Total -->
                <b-col cols="12" md="6" class="mt-md-6 d-flex justify-content-end" order="1" order-md="2">
                  <div class="invoice-total-wrapper">

                    <div class="invoice-total-item" v-if="salesorderId.discount > 0">
                      <p class="invoice-total-title">Discount</p>
                      <p class="invoice-total-amount">
                        {{ currencySymbol }} {{ parseFloat(salesorderId.discount).toFixed(2) }}
                      </p>
                    </div>

                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Subtotal:</p>
                      <p class="invoice-total-amount">
                        {{ currencySymbol }} {{ parseFloat(salesorderId.subTotal).toFixed(2) }}
                      </p>
                    </div>

                    <div class="invoice-total-item" v-if="vat">
                      <p class="invoice-total-title">VAT</p>
                      <p class="invoice-total-amount">
                        {{ currencySymbol }} {{ parseFloat(salesorderId.tax).toFixed(2) }}
                      </p>
                    </div>

                    <hr class="my-50" />
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Total:</p>
                      <p class="invoice-total-amount">
                        {{ currencySymbol }} {{ parseFloat(salesorderId.total).toFixed(2) }}
                      </p>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>

            <!-- Spacer -->
            <hr class="invoice-spacing" />

            <!-- Note -->
            <b-card-body class="invoice-padding pt-0 px-0">
              <span class="font-weight-bold">Note: </span>
              {{ note }}
            </b-card-body>
          </b-card>
        </b-form>
      </b-col>

      <!-- Right Col: Card -->
      <b-col cols="12" md="4" xl="3" class="invoice-actions">
        <!-- Action Buttons -->
        <b-card>
          <!-- Button: Print -->
          <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="outline-secondary" class="mb-75" block
            @click="printSo">
            Print / Download
          </b-button>

          <b-button v-if="whenSelected.tel && tenant" v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="info" class="mb-75"
            @click="openWhatsApp" block>
            <img src="@/assets/images/logo/whatsapp.png" class="w-10" />
            Whatsapp
          </b-button>

          <b-button variant="primary" class="mb-75" block v-if="
            this.salesorderId.status != 3 && this.salesorderId.status != 4
          " @click="checkInventory">
            Check Inventory & Confirm
          </b-button>
          <b-button variant="primary" class="mb-75" block :to="`/proforma/edit/${this.$route.params.id}`">
            Edit
          </b-button>

          <!-- Documents -->
          <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="primary" class="mb-75"
            @click="handleProformaDocBtn(id)" block>
            Documents
          </b-button>

          <b-modal ref="modal-view-proforma-document" id="modal-view-proforma-document" ok-only ok-title="View" centered
            size="lg" title="View Documents" :hide-footer="true">
            <DocumentUpload @deleteFile="deleteFile" @downloadFile="downloadFile" @uploadFiles="uploadFiles"
              :documentDetails="documentDetails" />
          </b-modal>
          <!-- Documents -->

        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import Address from "@core/layouts/components/Address.vue";
import CompanyName from "@core/layouts/components/CompanyName.vue";
import { ref } from "@vue/composition-api";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import DocumentUpload from "@/views/component/DocumentUpload.vue";
import ClientAddress from "@/@core/layouts/components/ClientAddress.vue";

import {
  deleteProformaDocument,
  uploadProformaMultipleDocuments,
  uploadProformaDocument,
  downloadProformaDocument,
} from "@/store/salesorders/services";
import { mapActions, mapGetters } from "vuex";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";
import { PermissionList } from "@/libs/defaultList";
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
  BFormSelect,
  BTable,
  BSpinner,
  
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { CurrencySymbols } from "@/libs/defaultList";
import {
  customSwal,
  customError,
  customLoader,
  fnSortingDropdown,
} from "@/libs/customFn";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BFormSelect,
    BCardText,
    BTable,
    BForm,
    BFormGroup,
    BSpinner,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    flatPickr,
    vSelect,
    Logo,
    Address,
    CompanyName,
    ClientAddress,
    DocumentUpload
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  data() {
    return {
      id: this.$route.params.id,
      tenant: localStorage.getItem("userTenant"),
      vat: JSON.parse(localStorage.getItem("userData")).vat,
      brn: JSON.parse(localStorage.getItem("userData")).brn,
      companyName: localStorage.getItem("userTenant"),
      optionsCustomer: [],
      optionsProduct: [],
      optionsSalesPerson: [],
      salesPersonId: "",
      leadClientId: "",
      orderType: "",
      dueDate: "",
      whenSelected: [],
      issuedDate: "",
      note: "",
      subTotal: 0,
      baseUrl: process.env.VUE_APP_MAIN_URL,
      fields: [
        {
          key: "productImg",
          label: "Product",
          formatter: (value, key, item) => {
            if (item.itemId) {

              // Directly set the image src to the API endpoint
              let src = `${baseUrl}selfservices/getproductimage?ProductID=${item.itemId}`;
              console.log("src", src);
              return src;
            }

          },
        },
        { key: "itemName", label: "Item Name", span: "Item Name" },
        { key: "description", label: "DESCRIPTION", span: "DESCRIPTION" },
        // { key: "cost", label: "COST (Rs)", span: "UNIT PRICE (RS)" },
        { key: "qty", label: "QTY", span: "QUANTITY" },
        // { key: "discount", label: "Discount (Rs)", span: "DISCOUNT" },

        { key: "price", label: "Total", span: "TOTAL" },
      ],
      taxOptions: [
        { value: 0, text: "0%" },
        { value: 1, text: "15%" },
      ],
      tax: 0,
      proformaPerson: "",
      currencySymbol: "Rs",
      ///order type
      optionsOrderType: [
        { value: null, text: "Please select an option" },
        // { value: 0, text: "Fixed Order" },
        { value: 1, text: "Variable Order" },
        { value: 2, text: "OneOff Order" },
      ],
      documentDetails: {
        isDelete: false,
        documentList: [],
      },
    };
  },
  mixins: [heightTransition],
  mounted() {
    this.initTrHeight();
  },
  computed: {



    dynamicFields() {
      // Base fields
      let baseFields = this.vat ? [
        { key: "itemName", label: "Item Name", span: "Item Name" },
        { key: "description", label: "DESCRIPTION", span: "DESCRIPTION" },
        { key: "qty", label: "QTY", span: "QUANTITY" },
        { key: "VAT", label: "VAT", span: "VAT" },
        { key: "price", label: "Total", span: "TOTAL" },
      ]
      :
      [ { key: "itemName", label: "Item Name", span: "Item Name" },
        { key: "description", label: "DESCRIPTION", span: "DESCRIPTION" },
        { key: "qty", label: "QTY", span: "QUANTITY" },
        { key: "price", label: "Total", span: "TOTAL" },];



      // Add ProductImage field if chosen
      if (this.isFieldChosen("ProductImage")) {
        baseFields.unshift({
          key: "productImg",
          label: "Product",
          formatter: (value, key, item) => {
            if (item.itemId) {
              let src = `${this.baseUrl}selfservices/getproductimage?ProductID=${item.itemId}`;
              console.log("src", src);
              return src;
            }
            return "-";
          },
        });
      }

      return baseFields;
    },
    ...mapGetters("salesOrderModule", {
      salesorderId: "salesorderId",
      inventoryStatus: "inventoryStatus",
      documents: "documents",
      loading: "loading",
    }),
    ...mapGetters("tenantModule", {
      tenantFields: "tenantFields",
    }),
    ...mapGetters("customerModule", {
      CustomerList: "customers",
      custId: "custId",
      loading: "loading",
    }),
    ...mapGetters("leadModule", {
      CustomerList: "leads",
      leadId: "leadId",
      loading: "loading",
    }),
    ...mapGetters("productModule", {
      ProductList: "product",
      loading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),

    ...mapGetters("warehouseModule", {
      warehouse: "warehouse",
      loading: "loading",
    }),

    ...mapGetters("invoiceModule", {
      invoices: "invoices",
      loadingInvoice: "loading",
    }),
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    getWarehouse(id){
      const wareh = this.warehouse.find((s) => s.id === id);
      return wareh ? wareh.name : "";
    },

    showNoImage(event) {
      // If the image fails to load, replace it with text "No Image"
      const parentElement = event.target.parentNode;
      if (parentElement) {
        parentElement.innerHTML = '<span>-</span>';
      }
    },
    isFieldChosen(key) {
      const result = this.chosenFields.some((field) => field.key === key);
      return result;
    },
    async handleProformaDocBtn(referenceId) {
      try {
        await this.getProformaDocumentListAction(referenceId);
        if (this.documents.length > 0) {
          let loader = this.$swal({
            title: "Processing...",
            text: "Please wait while the document(s) is being featched",
            onOpen: () => {
              this.$swal.showLoading();
            },
            allowOutsideClick: () => !this.$swal.isLoading(),
            buttonsStyling: false,
            showConfirmButton: false,
          });
          this.documentDetails.documentList = this.documents;
          this.documentDetails.isDelete = true;
          this.$swal.close();
        }
        this.$refs["modal-view-proforma-document"].show();
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    },

    async downloadFile(id, fileName) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being prepared for download",
        onOpen: () => {
          loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await downloadProformaDocument(id);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type:
              response.headers["content-type"] || "application/octet-stream",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error("Download failed:", error);
        loader.close();
        this.error("Failed to download the file. Please try again."); // Updated error message for better clarity
      }
    },
    async uploadFiles(selectedFiles) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document(s) is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
      const referenceId = this.id;

      const maxSize = 20 * 1024 * 1024;
        if (this.selectedFiles && this.selectedFiles.size > maxSize) {
          alert('File size exceeds 20 MB limit. Please choose a smaller file.');
          this.submitting = false;
          return;
        }

      if (selectedFiles.length > 1) {
        await uploadProformaMultipleDocuments(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      } else if (selectedFiles.length < 2) {
        await uploadProformaDocument(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      }
      await this.getProformaDocumentListAction(referenceId);
      this.documentDetails.isDelete = true;
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-proforma-document");
      });
    },

    async deleteFile(id) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being deleted",
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await deleteProformaDocument(id)
        .then((response) => {
          loader.close();
          customSwal("Document deleted successfully!");
        })
        .catch((error) => {
          loader.close();
          customError(error);
        });

      await this.getProformaDocumentListAction(this.id);
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-proforma-document");
      });
    },

    beautifyDate(dateString) {
      const date = new Date(dateString);
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return date.toLocaleDateString("en-US", options);
    },
    printSo() {
      window.print();
    },
    formatDate(timestamp) {
      return new Date(timestamp).toLocaleDateString();
    },
    ...mapActions("tenantModule", [
      "getTenantFCByModuleAction",
      "updateTenantFCAction",
    ]),

    ...mapActions("warehouseModule", [
      "getWarehouseListAction"
    ]),

    ...mapActions("customerModule", [
      "getCustomersListAction",
      "getCustomersByIDAction",
    ]),
    ...mapActions("leadModule", [
      "getLeadByIDAction",
      
    ]),
    ...mapActions("productModule", ["getProductListAction", "getProductIDAction"]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("salesOrderModule", [
      "getSalesOrdersByIDAction",
      "checkInventoryAction",
      "updateSalesOrdersAction",
      "getProformaDocumentListAction"
    ]),
    ...mapActions("invoiceModule", ["addInvoicesAction"]),
    addNewItemInItemForm() {
      this.invoiceData.items.push(
        JSON.parse(JSON.stringify(this.itemFormBlankItem))
      );

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
        setTimeout(() => {
          this.$refs.form.style.overflow = null;
        }, 350);
      });
    },
    error2(error) {
      this.$swal({
        title: "Error!",
        text: error.response.data.message,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    inventoryAvailable() {
      this.$swal({
        title: "Stock Available!",
        text: "Do you want to confirm invoice?",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "Yes",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.sendInvoice();
        }
      });
    },

    openWhatsApp() {
      const message = `Please find attached the Proforma for the recent transaction with ${this.companyName}. ${process.env.VUE_APP_CRM_URL}proforma/${this.tenant}/${this.id}`;
      const url = `https://web.whatsapp.com/send/?phone=${this.whenSelected.tel}&text=${message}&type=phone_number`;
      window.open(url, "_blank");
    },

    sendInvoice() {
      this.$swal({
        title: "Loading...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          this.$swal.showLoading();
        },
      });
      console.log("this.salesorder", this.salesorderId);
      let payload = {
        leadClientId: this.salesorderId.leadClientId,
        salesPersonId: this.proformaPerson,
        dueDate: this.salesorderId.dueDate,
        notes: this.salesorderId.note,
        status: 0,
        invoiceType: this.salesorderId.orderType,
        isActive: true,
        discount: this.salesorderId.discount,
        discountType: this.salesorderId.discountType,
        paymentMethod: "string",
        subTotal: this.salesorderId.subTotal,
        currency: this.salesorderId.currency,
        tax: this.salesorderId.tax,
        orderId: this.id,
        total: this.salesorderId.total,
        warehouseId: this.salesorderId.warehouseId,
        invoiceItem: this.salesorderId.orderItems.map((event) => ({
          itemId: event.itemId,
          description: event.description,
          quantity: event.qty,
          price: event.price,
          tax: event.tax,
          cost: event.cost,
          discountType: event.discountType,
          discount: event.discount,
        })),
      };
      console.log("payload", payload);
      this.addInvoicesAction(payload)
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Invoice confirmed!",
            text: "Your invoice has been created",
            customClass: {
              confirmButton: "btn btn-success",
            },
          }).then(() => {
            this.$router.push("/invoice/view/" + response.data.result.id);
          });
        })
        .catch((error) => {
          this.$swal.close();
          this.error2(error);
        });
    },
    // onDemand() {
    //   this.$swal({
    //     title: "Stock not available!",
    //     text: "Send to production or purchase order?",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonText: "Yes, confirm!",
    //     customClass: {
    //       confirmButton: "btn btn-primary",
    //       cancelButton: "btn btn-outline-danger ml-1",
    //     },
    //     buttonsStyling: false,
    //   }).then((result) => {
    //     if (result.value) {
    //       this.changeStatus();
    //     }
    //   });
    // },
    async onDemand() {
  try {
    const inhouseProducts = [];
    const nonInhouseProducts = [];
    for (const item of this.salesorderId.orderItems) {
      const productDetails = await this.getProductIDAction(item.itemId);

      if (productDetails.inHouseManufactured) {
        inhouseProducts.push(productDetails);
      } else {
        nonInhouseProducts.push(productDetails);
      }
    }

    console.log("🚀 ~ onDemand ~ inhouseProducts:", inhouseProducts)
    console.log("🚀 ~ onDemand ~ nonInhouseProducts:", nonInhouseProducts)

    let title = "";
    let text = "";
    let confirmButtonText = "";
    let showCancelButton = true;

    if (inhouseProducts.length === this.salesorderId.orderItems.length) {
      title = "Stock not available!";
      text = "Send to production?";
      confirmButtonText = "Yes, confirm!";
    } else if (nonInhouseProducts.length === this.salesorderId.orderItems.length) {

      title = "Stock not available!";
      text = "Refill your stock by issuing a Purchase Invoice.";
      confirmButtonText = "Okay";
      showCancelButton = false;
    } else {
      title = "Stock not available!";
      text = "Please restock by issuing a Purchase Invoice. For in-house products, do you want to proceed with production?";
      confirmButtonText = "Yes, confirm!";
    }

    this.$swal({
      title,
      text,
      icon: "warning",
      showCancelButton,
      confirmButtonText,
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-outline-danger ml-1",
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        if (inhouseProducts.length > 0) {
          if (HasPermission(PermissionList.Production_Production_Create)) {
            this.changeStatus();
          } else {
            this.$swal({
              icon: "error",
              title: "Permission Denied",
              text: "You don't have permission to access Production.",
              customClass: {
                confirmButton: "btn btn-danger",
              },
            });
          }
        }
        else if(nonInhouseProducts.length > 0){
          this.changeNotinStatus();
        }
      }
    });
  } catch (error) {
    console.error("Error fetching product details:", error);
    this.$swal({
      icon: "error",
      title: "Error",
      text: "An error occurred while processing your request. Please try again.",
      customClass: {
        confirmButton: "btn btn-danger",
      },
    });
  }
},
    changeStatus() {
      this.$swal({
        title: "Loading...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          this.$swal.showLoading();
        },
      });
      let payload = {
        id: this.id,
        orderNumber: this.salesorderId.orderNumber,
        leadClientId: this.salesorderId.leadClientId,
        salesPersonId: this.proformaPerson,
        issuedDate: this.salesorderId.issuedDate,
        dueDate: this.salesorderId.dueDate,
        note: this.salesorderId.note,
        status: 1,
        orderType: this.salesorderId.orderType,
        isActive: true,
        paymentMethod: "string",
        subTotal: this.salesorderId.subTotal,
        currency: this.salesorderId.currency,
        tax: this.salesorderId.tax,
        total: this.salesorderId.total,
        discount: this.salesorderId.discount,
        discountType: this.salesorderId.discountType,
        warehouseId: this.salesorderId.warehouseId,
        orderItems: this.salesorderId.orderItems,
      };
      this.updateSalesOrdersAction(payload)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Product on demand!",
            text: "Please wait for production",
            customClass: {
              confirmButton: "btn btn-success",
            },
          }).then(() => {
            window.location.reload();
          });
        })
        .catch((error) => {
          this.error(error);
        });
    },
    changeNotinStatus() {
      this.$swal({
        title: "Loading...",
        text: "Setting your product status to 'On Demand'.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          this.$swal.showLoading();
        },
      });
      let payload = {
        id: this.id,
        orderNumber: this.salesorderId.orderNumber,
        leadClientId: this.salesorderId.leadClientId,
        salesPersonId: this.proformaPerson,
        issuedDate: this.salesorderId.issuedDate,
        dueDate: this.salesorderId.dueDate,
        note: this.salesorderId.note,
        status: 1,
        orderType: this.salesorderId.orderType,
        isActive: true,
        paymentMethod: "string",
        subTotal: this.salesorderId.subTotal,
        currency: this.salesorderId.currency,
        tax: this.salesorderId.tax,
        total: this.salesorderId.total,
        discount: this.salesorderId.discount,
        discountType: this.salesorderId.discountType,
        warehouseId: this.salesorderId.warehouseId,
        orderItems: this.salesorderId.orderItems,
      };
      this.updateSalesOrdersAction(payload)
      .then(() => {
          this.$swal({
            icon: "success",
            title: "Product on demand!",
            customClass: {
              confirmButton: "btn btn-success",
            },
          }).then(() => {
            window.location.reload();
          });
        })
        .catch((error) => {
          this.error(error);
        });
    },
    checkInventory() {
      this.$swal({
        title: "Checking Inventory",
        html: '<b-spinner span="Loading..."></b-spinner><p>Please wait while we check the inventory</p>',
        showConfirmButton: false,
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading();
          setTimeout(() => {
            this.checkInventoryAction(this.id)
              .then(() => {
                if (this.inventoryStatus.isStockAvailable) {
                  this.inventoryAvailable();
                } else {
                  this.onDemand();
                }
              })
              .catch(() => {
                this.errorInventoryCheck();
              });
          }, 3000);
        },
      }).then(() => {
        this.$swal.close();
      });
    },

    getOptionsOrder(orderType) {
      switch (orderType) {
        // case 0:
        //   return "Fixed Order";
        case 1:
          return "Variable Order";
        case 2:
          return "OneOff Order";
        default:
          return ;
      }
    },

    errorInventoryCheck() {
      this.$swal({
        title: "Inventory Check Failed",
        text: "Inventory Check has failed, please try again later",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    // error
    error(error) {
      this.$swal({
        title: "Error!" + error.response.data.title,
        text: error.response.data.errors.request,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    removeItem(index) {
      this.invoiceData.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },

    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
    customerSelected(id) {


      this.getLeadByIDAction(id)
          .then((response) => {
            console.log("leadiddddddddddddddd", this.leadId);
            this.whenSelected = this.leadId;

          })
          .catch((error) => {
            this.getCustomersByIDAction(id).then(
              (response) => {
                console.log("custttttttttttttttttt", this.custId);
                this.whenSelected = this.custId;
              }
            );
          });
    },
  },
  beforeMount() {
    this.getSalesPersonListAction();
    this.getWarehouseListAction();
    this.getProductListAction();
    this.getCustomersListAction();
  },
  async mounted() {
    await this.getTenantFCByModuleAction("SalesInvoice").then(() => {
      // Assign the fields after the action is complete
      this.chosenFields = this.tenantFields.selectedFieldConfig;
      console.log("Chosen Fields:", this.chosenFields);
    });
    console.log('Is "ProductImage" field chosen:', this.isFieldChosen("ProductImage"));

    if (this.SalesPersonList == undefined || this.SalesPersonList.length == 0)
      await this.getSalesPersonListAction();
    if (this.ProductList == undefined || this.ProductList.length == 0)
      await this.getProductListAction();
   
      await this.getCustomersListAction();

    await this.getSalesOrdersByIDAction(this.id).then(() => {
      this.proformaPerson = this.salesorderId.salesPersonId;
      this.leadClientId = this.salesorderId.leadClientId;
      this.salesPersonId = this.salesorderId.salesPersonId;
      this.issuedDate = this.salesorderId.issuedDate;
      this.dueDate = this.salesorderId.dueDate;
      this.note = this.salesorderId.note;
      this.orderType = this.salesorderId.orderType;
      this.invoiceData.items = this.salesorderId.orderItems.map((event) => ({
        value: event.itemId,
        id: `${event.itemName}`,
        cost: event.cost,
        qty: event.qty,
        tax: event.tax,
        purchase: event.price,
        description: event.description,
      }));
      if (this.salesorderId.currency == null) this.salesorderId.currency = "MUR";
      this.currencySymbol = CurrencySymbols[this.salesorderId.currency];




    });

    this.getSalesPersonListAction().then(() => {
      this.SalesPersonList.forEach((element) => {
        if (element.id == this.salesorderId.salesPersonId) {
          this.salesorderId.salesPersonId =
            element.firstName + " " + element.lastName;
        }
      });
    });

    console.log("warehouse", this.warehouse);
    this.getWarehouseListAction().then(() => {
this.warehouse.foreach((warehousen) => {
if(warehousen.id == this.salesPersonId.warehouseId) {
  this.salesPersonId.warehouseId = warehousen.name
}
});
    });


    this.customerSelected(this.salesorderId.leadClientId) ;

    this.SalesPersonList.map((v, i) =>
      this.optionsSalesPerson.push({ value: v.id, text: `${v.name}` })
    );

    this.ProductList.map((v, i) => {
      v.qty = 1;
      this.optionsProduct.push({
        value: v.id,
        itemTitle: `${v.name}`,
        cost: v.salePrice,
        tax: v.saleTaxPercentage,
        purchase: v.purchasePrice,
        profit: v.markUpPercentage,
        description: v.description,
      });
    });
  },
  setup() {
    const itemFormBlankItem = {
      item: null,
      value: null,
      cost: 0,
      purchase: 0,
      qty: 0,
      tax: 0,
      profit: 0,
      description: "",
    };

    const invoiceData = ref({
      id: 5037,
      client: null,

      // ? Set single Item in form for adding data
      items: [JSON.parse(JSON.stringify(itemFormBlankItem))],

      salesPerson: "",
      note: "It was a pleasure working with you and your team. We hope you will keep us in mind for future freelance projects. Thank You!",
      paymentMethod: null,
    });

    const updateItemForm = (index, val) => {
      console.log(val);
      const { cost, qty, description, purchase, tax, profit, value } = val;
      invoiceData.value.items[index].cost = cost;
      invoiceData.value.items[index].qty = qty;
      invoiceData.value.items[index].value = value;
      invoiceData.value.items[index].tax = tax;
      invoiceData.value.items[index].profit = profit;
      invoiceData.value.items[index].purchase = purchase;
      invoiceData.value.items[index].description = description;
    };

    return {
      invoiceData,
      updateItemForm,
      itemFormBlankItem,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@media print {
  a[href]:after {
    content: none !important;
  }

  html,
  body {
    height: 99% !important;
  }

  // Global Styles
  .invoice-date-title {
    color: black !important;
  }

  span {
    color: black !important;
    font-size: 17.5px !important;
  }

  * {
    color: black !important;
  }

  body {
    background-color: transparent !important;
    font-size: 17.5px !important;
    color: black !important;
  }

  nav.header-navbar {
    display: none;
  }

  .flatpickr-input {
    font-size: 17.5px !important;
    color: black !important;
  }

  nav.header-navbar {
    display: none;
  }

  .main-menu {
    display: none;
  }

  .header-navbar-shadow {
    display: none !important;
  }

  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }

  footer.footer {
    display: none;
  }

  .card {
    background-color: transparent;
    box-shadow: none;
  }

  .customizer-toggle {
    display: none !important;
  }

  .content-header {
    display: none !important;
  }

  .invoice-edit-input {
    border: none;
  }

  // Invoice Specific Styles
  .invoice-add-wrapper {
    .row.invoice-add {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            >.col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}

@media print {
  .form-control {
    border: 0;
    width: unset;
    padding: 0;
    text-align: right;
  }
}
</style>
